module.exports = __webpack_public_path__ + "img/person-blue.e561e52f.svg";